import { Message, proto3, protoInt64 } from '@bufbuild/protobuf';
/**
 * @generated from message plugnmeet.CreatePollReq
 */
export class CreatePollReq extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string room_id = 1;
         */
        this.roomId = '';
        /**
         * @generated from field: string user_id = 2;
         */
        this.userId = '';
        /**
         * @generated from field: string poll_id = 3;
         */
        this.pollId = '';
        /**
         * @generated from field: string question = 4;
         */
        this.question = '';
        /**
         * @generated from field: repeated plugnmeet.CreatePollOptions options = 5;
         */
        this.options = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CreatePollReq().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreatePollReq().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreatePollReq().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreatePollReq, a, b);
    }
}
CreatePollReq.runtime = proto3;
CreatePollReq.typeName = 'plugnmeet.CreatePollReq';
CreatePollReq.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'room_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'user_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'poll_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'question', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    {
        no: 5,
        name: 'options',
        kind: 'message',
        T: CreatePollOptions,
        repeated: true,
    },
]);
/**
 * @generated from message plugnmeet.CreatePollOptions
 */
export class CreatePollOptions extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: uint32 id = 1;
         */
        this.id = 0;
        /**
         * @generated from field: string text = 2;
         */
        this.text = '';
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new CreatePollOptions().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new CreatePollOptions().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new CreatePollOptions().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(CreatePollOptions, a, b);
    }
}
CreatePollOptions.runtime = proto3;
CreatePollOptions.typeName = 'plugnmeet.CreatePollOptions';
CreatePollOptions.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 13 /* ScalarType.UINT32 */ },
    { no: 2, name: 'text', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message plugnmeet.PollInfo
 */
export class PollInfo extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string id = 1;
         */
        this.id = '';
        /**
         * @generated from field: string room_id = 2;
         */
        this.roomId = '';
        /**
         * @generated from field: string question = 3;
         */
        this.question = '';
        /**
         * @generated from field: repeated plugnmeet.CreatePollOptions options = 4;
         */
        this.options = [];
        /**
         * @generated from field: bool is_running = 5;
         */
        this.isRunning = false;
        /**
         * @generated from field: int64 created = 6;
         */
        this.created = protoInt64.zero;
        /**
         * @generated from field: string created_by = 7;
         */
        this.createdBy = '';
        /**
         * @generated from field: string closed_by = 8;
         */
        this.closedBy = '';
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PollInfo().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PollInfo().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PollInfo().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PollInfo, a, b);
    }
}
PollInfo.runtime = proto3;
PollInfo.typeName = 'plugnmeet.PollInfo';
PollInfo.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'room_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'question', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    {
        no: 4,
        name: 'options',
        kind: 'message',
        T: CreatePollOptions,
        repeated: true,
    },
    { no: 5, name: 'is_running', kind: 'scalar', T: 8 /* ScalarType.BOOL */ },
    { no: 6, name: 'created', kind: 'scalar', T: 3 /* ScalarType.INT64 */ },
    { no: 7, name: 'created_by', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 8, name: 'closed_by', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message plugnmeet.SubmitPollResponseReq
 */
export class SubmitPollResponseReq extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string room_id = 1;
         */
        this.roomId = '';
        /**
         * @generated from field: string user_id = 2;
         */
        this.userId = '';
        /**
         * @generated from field: string name = 3;
         */
        this.name = '';
        /**
         * @generated from field: string poll_id = 4;
         */
        this.pollId = '';
        /**
         * @generated from field: uint64 selected_option = 5;
         */
        this.selectedOption = protoInt64.zero;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new SubmitPollResponseReq().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new SubmitPollResponseReq().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new SubmitPollResponseReq().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(SubmitPollResponseReq, a, b);
    }
}
SubmitPollResponseReq.runtime = proto3;
SubmitPollResponseReq.typeName = 'plugnmeet.SubmitPollResponseReq';
SubmitPollResponseReq.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'room_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'user_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'name', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 4, name: 'poll_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    {
        no: 5,
        name: 'selected_option',
        kind: 'scalar',
        T: 4 /* ScalarType.UINT64 */,
    },
]);
/**
 * @generated from message plugnmeet.ClosePollReq
 */
export class ClosePollReq extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string room_id = 1;
         */
        this.roomId = '';
        /**
         * @generated from field: string user_id = 2;
         */
        this.userId = '';
        /**
         * @generated from field: string poll_id = 3;
         */
        this.pollId = '';
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new ClosePollReq().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new ClosePollReq().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new ClosePollReq().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(ClosePollReq, a, b);
    }
}
ClosePollReq.runtime = proto3;
ClosePollReq.typeName = 'plugnmeet.ClosePollReq';
ClosePollReq.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'room_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 2, name: 'user_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'poll_id', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
]);
/**
 * @generated from message plugnmeet.PollResponsesResultOptions
 */
export class PollResponsesResultOptions extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: uint64 id = 1;
         */
        this.id = protoInt64.zero;
        /**
         * @generated from field: string text = 2;
         */
        this.text = '';
        /**
         * @generated from field: uint64 vote_count = 3;
         */
        this.voteCount = protoInt64.zero;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PollResponsesResultOptions().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PollResponsesResultOptions().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PollResponsesResultOptions().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PollResponsesResultOptions, a, b);
    }
}
PollResponsesResultOptions.runtime = proto3;
PollResponsesResultOptions.typeName = 'plugnmeet.PollResponsesResultOptions';
PollResponsesResultOptions.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'id', kind: 'scalar', T: 4 /* ScalarType.UINT64 */ },
    { no: 2, name: 'text', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    { no: 3, name: 'vote_count', kind: 'scalar', T: 4 /* ScalarType.UINT64 */ },
]);
/**
 * @generated from message plugnmeet.PollResponsesResult
 */
export class PollResponsesResult extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: string question = 1;
         */
        this.question = '';
        /**
         * @generated from field: uint64 total_responses = 2;
         */
        this.totalResponses = protoInt64.zero;
        /**
         * @generated from field: repeated plugnmeet.PollResponsesResultOptions options = 3;
         */
        this.options = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PollResponsesResult().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PollResponsesResult().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PollResponsesResult().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PollResponsesResult, a, b);
    }
}
PollResponsesResult.runtime = proto3;
PollResponsesResult.typeName = 'plugnmeet.PollResponsesResult';
PollResponsesResult.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'question', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    {
        no: 2,
        name: 'total_responses',
        kind: 'scalar',
        T: 4 /* ScalarType.UINT64 */,
    },
    {
        no: 3,
        name: 'options',
        kind: 'message',
        T: PollResponsesResultOptions,
        repeated: true,
    },
]);
/**
 * @generated from message plugnmeet.PollsStats
 */
export class PollsStats extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: uint64 total_polls = 1;
         */
        this.totalPolls = protoInt64.zero;
        /**
         * @generated from field: uint64 total_running = 2;
         */
        this.totalRunning = protoInt64.zero;
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PollsStats().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PollsStats().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PollsStats().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PollsStats, a, b);
    }
}
PollsStats.runtime = proto3;
PollsStats.typeName = 'plugnmeet.PollsStats';
PollsStats.fields = proto3.util.newFieldList(() => [
    {
        no: 1,
        name: 'total_polls',
        kind: 'scalar',
        T: 4 /* ScalarType.UINT64 */,
    },
    {
        no: 2,
        name: 'total_running',
        kind: 'scalar',
        T: 4 /* ScalarType.UINT64 */,
    },
]);
/**
 * @generated from message plugnmeet.PollResponse
 */
export class PollResponse extends Message {
    constructor(data) {
        super();
        /**
         * @generated from field: bool status = 1;
         */
        this.status = false;
        /**
         * @generated from field: string msg = 2;
         */
        this.msg = '';
        /**
         * @generated from field: map<string, string> responses = 6;
         */
        this.responses = {};
        /**
         * @generated from field: repeated plugnmeet.PollInfo polls = 7;
         */
        this.polls = [];
        proto3.util.initPartial(data, this);
    }
    static fromBinary(bytes, options) {
        return new PollResponse().fromBinary(bytes, options);
    }
    static fromJson(jsonValue, options) {
        return new PollResponse().fromJson(jsonValue, options);
    }
    static fromJsonString(jsonString, options) {
        return new PollResponse().fromJsonString(jsonString, options);
    }
    static equals(a, b) {
        return proto3.util.equals(PollResponse, a, b);
    }
}
PollResponse.runtime = proto3;
PollResponse.typeName = 'plugnmeet.PollResponse';
PollResponse.fields = proto3.util.newFieldList(() => [
    { no: 1, name: 'status', kind: 'scalar', T: 8 /* ScalarType.BOOL */ },
    { no: 2, name: 'msg', kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    {
        no: 3,
        name: 'poll_id',
        kind: 'scalar',
        T: 9 /* ScalarType.STRING */,
        opt: true,
    },
    {
        no: 4,
        name: 'total_responses',
        kind: 'scalar',
        T: 4 /* ScalarType.UINT64 */,
        opt: true,
    },
    {
        no: 5,
        name: 'voted',
        kind: 'scalar',
        T: 4 /* ScalarType.UINT64 */,
        opt: true,
    },
    {
        no: 6,
        name: 'responses',
        kind: 'map',
        K: 9 /* ScalarType.STRING */,
        V: { kind: 'scalar', T: 9 /* ScalarType.STRING */ },
    },
    { no: 7, name: 'polls', kind: 'message', T: PollInfo, repeated: true },
    { no: 8, name: 'stats', kind: 'message', T: PollsStats, opt: true },
    {
        no: 9,
        name: 'total_polls',
        kind: 'scalar',
        T: 4 /* ScalarType.UINT64 */,
        opt: true,
    },
    {
        no: 10,
        name: 'total_running',
        kind: 'scalar',
        T: 4 /* ScalarType.UINT64 */,
        opt: true,
    },
    {
        no: 11,
        name: 'poll_responses_result',
        kind: 'message',
        T: PollResponsesResult,
        opt: true,
    },
]);
